import { Flash } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconFlash12Line = createIcon(Flash, 12, "Line");
export const IconFlash16Line = createIcon(Flash, 16, "Line");
export const IconFlash20Line = createIcon(Flash, 20, "Line");
export const IconFlash24Line = createIcon(Flash, 24, "Line");
export const IconFlash32Line = createIcon(Flash, 32, "Line");
export const IconFlash48Line = createIcon(Flash, 48, "Line");
export const IconFlash64Line = createIcon(Flash, 64, "Line");
